import React from "react";
import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const UserPreferenceService = {
  inserUpdateUserUnitPreference,
  getUserUnitPreference,
};

async function getUserUnitPreference(userId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_USER_UNIT_PREFERENCES_BY_USER_ID(userId),
    authHeader()
  );
  return response;
}

async function inserUpdateUserUnitPreference(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_USER_PREFERENCES}`,
    formObj,
    authHeader()
  );
  return response;
}
